// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject, fromEvent, timer, merge } from 'rxjs';

// --- HS Code
import { EnvService } from './env.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {
  private _idleState$: BehaviorSubject<string> = new BehaviorSubject<string>('active');
  get idleState$(): Observable<string> {
    return this._idleState$;
  }

  private readonly events = [
    'scroll',
    'keypress',
    'touchmove',
    'touchend',
    'click',
    'mousemove'
  ];

  private _isIdle = false;
  private idleTimeCounter: number;

  constructor(private envService: EnvService) {
    this.idleTimeCounter = envService.getInt('idleTimeThreshold');

    const eventStreams = this.events.map((ev) => fromEvent(document, ev));
    merge(...eventStreams).subscribe(() => {
      this.idleTimeCounter = envService.getInt('idleTimeThreshold');
      if (this._isIdle) {
        this._isIdle = false;
        this._idleState$.next('active');
      }
    });

    timer(60000, 60000).subscribe(() => {
      if (!this._isIdle) {
        this.idleTimeCounter--;
        if (this.idleTimeCounter <= 0) {
          this._isIdle = true;
          this._idleState$.next('idle');
        }
      }
    });
  }

  resetIdleTimeCounter(): void {
    this.idleTimeCounter = this.envService.getInt('idleTimeThreshold');
  }
}
